import ReactMarkdown from "react-markdown";

type MarkdownProps = {
  content: string;
  isSEOArticle?: boolean;
};

export const TipsMarkdown = ({ content }: MarkdownProps) => {
  return (
    <ReactMarkdown
      components={{
        h1: ({ node, ...props }) => (
          <h1
            className="mb-5 text-3xl font-bold md:mb-8 md:text-4xl"
            {...props}
          />
        ),
        h2: ({ node, ...props }) => (
          <h2
            className="my-3 text-2xl font-bold md:my-5 md:text-3xl"
            {...props}
          />
        ),
        h3: ({ node, ...props }) => (
          <h3
            className="my-3 text-xl font-semibold md:my-5 md:text-2xl"
            {...props}
          />
        ),
        p: ({ node, ...props }) => (
          <p className="mb-3 leading-6 md:mb-5 md:text-lg" {...props} />
        ),
        b: ({ node, ...props }) => <b className="font-bold" {...props} />,
        hr: ({ node, ...props }) => <hr className="mb-8 md:mb-10" {...props} />,
        ul: ({ node, ...props }) => (
          <ul className="pl-7 list-disc" {...props} />
        ),
        ol: ({ node, ...props }) => (
          <ol className="pl-7 list-decimal" {...props} />
        ),
        li: ({ node, ...props }) => (
          <li className="pb-3 md:text-lg" {...props} />
        ),
        a: ({ node, ...props }) => (
          <a className="font-bold text-cornflower-blue" {...props} />
        ),
        blockquote: ({ node, ...props }) => (
          <blockquote className="pl-3 italic text-black/50 border-l-4 border-black/10" {...props} />
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  );
};
